import React from 'react'
import CourseHeader from '../components/CourseHeader'
// import CourseCard from '../components/CourseCard'
// import { courseInfo } from '../assets/courseInfo'
import "./Styles.css"

const Courses = () => {
    return (
        <div className='courses-main-wrapper'>
            <CourseHeader />
            <div className='course-h-c'>
                <h2 className='courses-heading'>OUR COURSES</h2>
                {/* <div className='courses-wrapper'>
                    {courseInfo.map(item => {
                        console.log(item.name)
                        return (
                            <CourseCard key={item.id} name={item.name} description={item.description} />
                        )
                    })}
                </div> */}
            </div>
        </div>
    )
}

export default Courses
